import { ReactNode } from 'react';
import { ROUTES } from '@/common/constants/routes';
import {
  Box,
  Button,
  Flex,
  Heading,
  LogoCoverflex,
  Text,
} from '@coverflex-tech/hypernova';
import cx from 'classnames';
import { t } from 'i18next';
import { css } from './ErrorPage.css';

export const ErrorPage = ({
  redirectTo,
  reloadLabel = String(t('general.errors.generic_error.reload')),
  goHomeLabel = String(t('general.errors.generic_error.go_home')),
  onClick,
  title = String(t('general.errors.generic_error.title')),
  description = String(t('general.errors.generic_error.description')),
  errorCode,
  hideActions,
  embedded,
}: TErrorPageProps) => {
  return (
    <Box
      padding={!embedded ? '2xl' : undefined}
      flexDirection="column"
      gap="lg"
      className={cx(css.host, {
        [css.embedded]: embedded,
      })}
    >
      <LogoCoverflex className={css.logo} width="13rem" height="2.8rem" />
      <Flex flexDirection="column" gap="lg">
        {Boolean(errorCode) && <Text>{errorCode}</Text>}
        {title && <Heading level={2}>{title}</Heading>}
        <Text className={css.description}>{description}</Text>
        {!hideActions && (
          <Flex gap="lg">
            <Button
              variant="secondary"
              onClick={() => window.location.assign(ROUTES.ROOT)}
            >
              {goHomeLabel}
            </Button>
            <a
              href={redirectTo}
              onClick={(evt) => {
                if (!redirectTo) {
                  evt.preventDefault();

                  if (onClick) {
                    onClick();
                  }
                  window.location.reload();
                }
              }}
            >
              <Button variant="primary" presentational>
                {reloadLabel}
              </Button>
            </a>
          </Flex>
        )}
      </Flex>
    </Box>
  );
};

export type TErrorPageProps = {
  onClick?: () => void;
  reloadLabel?: ReactNode;
  goHomeLabel?: ReactNode;
  errorCode?: ReactNode;
  title?: ReactNode;
  description?: ReactNode;
  redirectTo?: string;
  hideActions?: boolean;
  embedded?: boolean;
};
